<div class="box">

  <app-button (click)="toggleSound()">
    @if (statesService.states.sound) {
      <span>🔇 <br> Ton aus</span>
    }
    @if (!statesService.states.sound) {
      <span>🔊 <br> Ton an</span>
    }
  </app-button>

  @if (statesService.states.started) {
    <app-button (click)="simulation.toggleSpeed()"
      [class.activated]="this.simulation.pet.timeInterval === 1000"
      >
      <span>⏩ <br> Vorspulen</span>
    </app-button>
  }

</div>
